import React, { Component } from 'react';
import { Field, change } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import checkboxFase from '../common/form/checkboxFase';

import {
  listarCamposConflitoDoAnel,
  normalizarValorConflitoFase,
} from './controladorFaseConflitoUtils';

class FaseConflitoControlador extends Component {
  constructor(props) {
    super(props);
    this.geralFasesConflito = this.geralFasesConflito.bind(this);
  }

  aplicarConflitosDoAnelNoForm() {
    if (!this.props.atualizarDoAnel || !this.props.aneis || !this.props.aneis[this.props.anelSelecionado]) {
      return;
    }

    const anel = this.props.aneis[this.props.anelSelecionado];
    listarCamposConflitoDoAnel(this.props.numeroFasesIni, this.props.numeroFases).forEach(fieldName => {
      if (anel[fieldName] !== undefined && anel[fieldName] !== null) {
        this.props.change('controladorForm', fieldName, normalizarValorConflitoFase(anel[fieldName]));
      }
    });
  }

  componentDidMount() {
    this.aplicarConflitosDoAnelNoForm();
  }

  componentDidUpdate(prevProps) {
    // Atualizar valores quando o anel selecionado mudar
    if (
      this.props.atualizarDoAnel &&
      (prevProps.anelSelecionado !== this.props.anelSelecionado ||
        prevProps.numeroFases !== this.props.numeroFases ||
        prevProps.numeroFasesIni !== this.props.numeroFasesIni)
    ) {
      this.aplicarConflitosDoAnelNoForm();
    }
  }

  geralFasesConflito() {
    let faseGrupoObj = [];
    let fasesIni = parseInt(this.props.numeroFasesIni) + 1;
    let fasesFin = this.props.numeroFases;

    for (let idxFase = fasesIni; idxFase <= fasesFin; idxFase++) {
      let faseObj = [];
      for (let idx = fasesIni; idx <= idxFase; idx++) {
        const fieldName = `fase${idx - 1}_fase${idxFase}`;

        // Sempre use o mesmo formato de Field, mantenha a simplicidade
        faseObj.push(
          <Field
            name={fieldName}
            key={fieldName}
            component={checkboxFase}
            label={`F${idx - 1} c/ F${idxFase}`}
            type="checkbox"
            disabled={this.props.disabled}
            onChange={(event, newValue) => {
              if (this.props.atualizarDoAnel && this.props.aneis && this.props.aneis[this.props.anelSelecionado]) {
                this.props.aneis[this.props.anelSelecionado][fieldName] = normalizarValorConflitoFase(newValue);
              }
            }}
          />,
        );
      }
      faseGrupoObj.push(<div key={`fase${idxFase}`}>{faseObj}</div>);
    }

    return faseGrupoObj;
  }

  render() {
    return (
      <div className="controlador-fases-conflito">
        <div className="controlador-fases-conflito-header">
          <div>
            <h5>
              <i className="fa fa-random" /> Fases não conflitantes
            </h5>
            <span>Marque combinações de fases que podem operar sem conflito.</span>
          </div>
        </div>
        <div className="controlador-fases-conflito-options">{this.geralFasesConflito()}</div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ change }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(FaseConflitoControlador);
